import React, {Component, Fragment} from 'react';
import { __ } from 'i18n-for-browser';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import RankingRow from '../elements/RankingRow';
import ContentContainer from '../elements/ContentContainer';
import GoBackButton from '../elements/GoBackButton';
import Loading from '../elements/Loading';
import Scrollbar from "react-scrollbars-custom";

import apiCall from '../apiCall';
import { getGroupAvatarUrl } from '../../helpers/groupHelper';

class Rankings extends Component {
  static propTypes = {
    history: PropTypes.shape({
      goBack: PropTypes.func,
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        projectId: PropTypes.string.isRequired,
        schoolClassId: PropTypes.string,
      }).isRequired,
    }).isRequired,
  };
  static defaultProps = {
    desktop: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      schoolClasses: [],
    };
    this.schoolClassId = parseInt(this.props.match.params.schoolClassId, 10);
    this.projectId = parseInt(this.props.match.params.projectId, 10);
    this.renderGroupRows = this.renderGroupRows.bind(this);
  }

  componentWillMount() {
    apiCall(`/schoolClass/${(this.schoolClassId ? `${this.schoolClassId}/` : '')}simGameSchoolClasses/${this.projectId}`)
      .then((schoolClasses) => {
        this.setState({ schoolClasses });
      });
  }

  renderGroupRows(groups) {
    const { schoolClass, gameState } = this.props;
    if (!groups || !groups.length) return null;
    if (gameState.hideScores) {
      return (
        <ContentContainer className="disabled-scores-container">
          <p className={'disabled-scores'}>{__('sim_tussenstand_uitgeschakeld')}</p>
        </ContentContainer>
      );
    };

    // Split groups in chunks of 8 for desktop view
    const arrayChunk = function(arr, chunkSize) {
      let groups = [], i;
      for (i = 0; i < arr.length; i += chunkSize) {
        groups.push(arr.slice(i, i + chunkSize));
      }
      return groups;
    };
    const columns = arrayChunk(groups, 10);
    return columns.map((column, y) => {
      return (
        <div key={y} className={'class-column' + (groups.length <= 10 ? ' single-column' : '')}>
          { column.map((grp, i) => {
            return (
              <Fragment key={grp.id}>
                <RankingRow
                  key={grp.id}
                  rank={(i + 1) + (y * 10)}
                  title={grp.name}
                  schoolClassFilter={this.schoolClassId && schoolClass.id}
                  color={grp.GroupTheme.color}
                  className={grp.SchoolClass.className}
                  showSchoolClassName={!this.schoolClassId}
                  points={grp.totalPoints}
                  avatar={getGroupAvatarUrl(grp, this.props.project, '')}
                />
              </Fragment>
            )
          }) }
        </div>
        )
    })
  }

  /**
   * Get page title from project or schoolclass
   * @return {String} Page title
   */
  getTitle = () => {
    const { project } = this.props;
    const { schoolClasses } = this.state;
    if (this.schoolClassId && Array.isArray(schoolClasses)) {
      const { className, classRoom } = schoolClasses.find((sc) => {
        return sc.id === this.schoolClassId;
      });
      return `${className}-${classRoom}`;
    }
    return project.nameSchoolPlace;
  }

  render() {
    const { schoolClasses } = this.state;
    const { desktop } = this.props;
    if (!schoolClasses.length) return <Loading />;
    const groups = schoolClasses.reduce((acc, sc) => {
      return acc.concat(sc.Groups.map(g => ({ ...g, SchoolClass: sc })));
    }, []).sort((a, b) => b.totalPoints - a.totalPoints);
    return (
      <div className={'rankings ' + (desktop ? 'portal-home school-ranking darkBckg' : '')}>
        <div className={'container'}>
          <div className={'title-block title-portal ' + (desktop ? 'title-small-center' : '')}>
            <GoBackButton history={this.props.history} />
            <h3>{this.getTitle()}</h3>
            <p>{__('sim_ranglijst')}</p>
          </div>
          <div className={'ranking-rows-container' + (groups.length <= 20 ? ' hidescroll' : '')}>
            { desktop ? (
              <Scrollbar
                className={'horizontal'}
                permanentTrackX={true}
                noScrollY={true}
                style={ {width: '100%', height: 'auto', minHeight: 600} } >
                {this.renderGroupRows(groups)}
                <div style={{ padding: '2px' }} className="extra-spacing" />
              </Scrollbar>
            ) : (
              this.renderGroupRows(groups)
            )}

          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  project: state.project,
  schoolClass: state.schoolClass,
  gameState: state.gameState
}))(Rankings);



// WEBPACK FOOTER //
// ./src/components/routes/Rankings.js